<template>
  <div class="form_deposit">
    <div class="content">
      <div class="form_main">
        <form id="payment-form" method="POST" :action="checkoutCCData.action">
          <div class="one-liner">
            <div class="card-frame"></div>
            <button id="pay-button" data-testid="pay-button" disabled>
              Submit {{ checkoutCCData.currency }} {{ checkoutCCData.amount }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/page/deposit';
import { apiCc_checkout_payment } from '@/resource';
import sensorsHandler from '@/util/sensorsdata/handler';

export default {
  name: 'Checkout',
  mixins: [mixin],
  data() {
    return {
      checkoutToken: ''
    };
  },
  computed: {
    checkoutCCData() {
      return this.$store.state.payment.checkoutCCData;
    },
    orderInfo() {
      return this.$store.state.payment.orderInfo;
    }
  },
  watch: {
    checkoutCCData(newValue) {
      this.init(newValue);
    }
  },
  mounted() {
    this.init(this.checkoutCCData);
  },
  beforeDestroy() {
    this.$store.dispatch('payment/actionSetCheckoutCCData', {});
  },
  methods: {
    init(data) {
      return new Promise(resolve => {
        this.insertJs(data.source);
        setTimeout(() => {
          resolve();
        }, 1500);
      }).then(() => {
        this.$nextTick(() => {
          if (Frames) {
            const vm = this;
            const payButton = document.getElementById('pay-button');
            const paymentForm = document.getElementById('payment-form');

            Frames.init({
              publicKey: data.publicKey,
              style: { base: { color: 'white' } }
            });

            sensorsHandler('DEPOSIT_STEP2_CCCHECKOUTPAGE_VIEW', this.orderInfo);

            Frames.addEventHandler(Frames.Events.CARD_VALIDATION_CHANGED, function (event) {
              console.log('CARD_VALIDATION_CHANGED: %o', event);
              payButton.disabled = !Frames.isCardValid();
            });

            Frames.addEventHandler(Frames.Events.CARD_TOKENIZED, function (event) {
              console.log(event.token);
              vm.secondSubmitForm(event.token);
            });

            paymentForm.addEventListener('submit', function (event) {
              payButton.disabled = true; // disables pay button once submitted
              event.preventDefault();
              Frames.submitCard();
            });
          } else this.errorMessage(this.$t('deposit.default.failed'));
        });
      });
    },
    submitDeposit() {
      return apiCc_checkout_payment(
        {
          mt4Account: this.checkoutCCData.accountNumber,
          depositAmount: this.checkoutCCData.amount,
          applicationNotes: '',
          token: this.checkoutToken
        },
        this.token
      );
    },
    secondSubmitForm(token) {
      if (token) {
        this.checkoutToken = token;
        this.submitDeposit()
          .then(result => {
            if (result.data.code == 0) {
              window.location = result.data.msg;
            }
            // else if (result.data.code == 300) {
            //     window.location = result.data.msg;
            // }
            else {
              this.errorMessage(this.$t('deposit.default.failed'));
              // re-calling anti-reuse token
              this.fetchToken()
                .then(resp => {
                  this.loading = false;
                })
                .catch(resp => {
                  this.loading = false;
                  this.errorMessage(this.$t('resetPassword.failed'));
                });
            }
          })
          .catch(err => {
            this.errorMessage(this.$t('deposit.default.failed'));
          });
      } else this.errorMessage(this.$t('deposit.default.failed'));
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/deposit/deposit.scss';
@import '@/assets/css/pages/deposit/checkout.scss';
</style>
